export interface SeDialogAction {
  action: () => any | Promise<any>
  destructive?: boolean
  buttonLabel: string
  primary?: boolean
  secondary?: boolean
}

export interface SeDialogButton {
  action: () => void
  className: string
  label: string
}

export interface SeDialogOptions {
  actions: SeDialogAction[]
  size?: SeDialogSize
}

export enum SeDialogVisibility {
  closed = 'closed',
  closing = 'closing',
  disabled = 'disabled',
  open = 'open',
  opening = 'opening'
}

export enum SeDialogSize {
  large = 'large',
  medium = 'medium',
  small = 'small',
}

export enum SeDialogActionType {
  primary = 'primary',
  secondary = 'secondary',
  destructive = 'destructive',
  minimal = 'minimal'
}
